/**
 * 한국어 → 영어 번역 사전
 * 키: 한국어 원문 (DOM에 나타나는 텍스트 그대로)
 * 값: 영어 번역
 *
 * ⚠️ 긴 문자열이 짧은 문자열보다 먼저 매칭되도록 i18n.ts에서 정렬 처리함.
 *    따라서 여기서는 순서를 신경 쓸 필요 없음.
 */
export const DICT_KO_EN: Record<string, string> = {
    "처리는 완료되었습니다. 알림 메일 발송이 지연되고 있습니다. 운영자에게 문의해주세요.": "The operation is complete. Notification emails are delayed. Please contact the administrator.",
    "처리는 완료되었지만 알림 메일 예약 여부를 확인하지 못했습니다. 같은 내용을 다시 등록하지 말고 운영자에게 문의해주세요.": "The operation is complete, but email scheduling could not be confirmed. Do not submit it again. Please contact the administrator.",
    "처리는 완료되었지만 화면을 새로 고치지 못했습니다. 페이지를 새로고침해주세요.": "The operation is complete, but the view could not be updated. Please refresh the page.",
    "그룹 생성·PI 지정": "Group creation and PI assignment",
    "생성된 그룹의 PI 이메일을 확인해주세요.": "Check the email address of the created group’s PI.",
    "현재 그룹 생성 권한과 대표자 정보를 확인해주세요.": "Check your current group creation permission and PI details.",
    "현재 그룹 생성 권한을 확인해주세요.": "Check your current permission to create groups.",
    "그룹 생성 처리 결과를 확인하지 못했습니다. 목록을 확인한 뒤 다시 시도해주세요.": "Could not confirm the group creation result. Check the list before trying again.",
    "파일 1개 · XLSX, CSV · 최대 10 MiB · 최대 1,000행": "One file · XLSX or CSV · Up to 10 MiB · Up to 1,000 rows",
    "구형 XLS 파일은 XLSX로 변환해 업로드해주세요.": "Convert legacy XLS files to XLSX before uploading.",
    "데이터 행": "Data rows (excluding blanks)",
    "CSV, XLSX 또는 XLS 파일을 선택해주세요.": "Select a CSV, XLSX or XLS file.",
    "파일은 10MiB 이하여야 합니다.": "The file must be 10 MiB or smaller.",
    "파일을 읽을 수 없습니다. 형식과 내용을 확인해주세요.": "The file could not be read. Check its format and contents.",
    "알 수 없는 열 제목입니다. 가져오기 양식을 사용해주세요.": "Unknown column name. Use the import template.",
    "열 제목이 중복되었습니다.": "A column name is duplicated.",
    "성과명(title) 열이 필요합니다.": "The title column is required.",
    "열 제목을 확인해주세요.": "Check the column names.",
    "수식은 사용할 수 없습니다. 값으로 변환해주세요.": "Formulas are not supported. Convert them to values.",
    "Excel 오류 값은 사용할 수 없습니다.": "Excel error values are not supported.",
    "줄바꿈이나 제어 문자는 사용할 수 없습니다.": "Line breaks and control characters are not allowed.",
    "Impact Factor는 0 이상의 유한한 숫자여야 합니다.": "Impact Factor must be a finite number of 0 or greater.",
    "Impact Factor에 저장 가능한 0 이상의 숫자를 입력해주세요.": "Enter a nonnegative Impact Factor within the supported range.",
    "성과명을 입력해주세요.": "Enter a research title.",
    "UTF-8 기준 65,535바이트 이내로 입력해주세요.": "Enter no more than 65,535 bytes in UTF-8.",
    "첫 행에 열 제목이 필요합니다.": "The first row must contain column names.",
    "빈 행을 포함하여 10,001행 이내의 파일을 사용해주세요.": "Use a file with no more than 10,001 rows, including blank rows.",
    "한 번에 최대 1,000개의 실적을 등록할 수 있습니다.": "You can import up to 1,000 research records at a time.",
    "열 제목보다 데이터 열이 많습니다.": "The row has more data columns than the header.",
    "파일에 오류가 있어 등록하지 않았습니다.": "The file contains errors. No records were imported.",
    "등록할 실적이 없습니다.": "There are no research records to import.",
    "CSV 인코딩은 UTF-8 또는 CP949를 사용해주세요.": "Use UTF-8 or CP949 encoding for CSV files.",
    "파일은 최대 64열 이내여야 합니다.": "The file must contain no more than 64 columns.",
    "Excel 압축 해제 크기는 50MiB 이하여야 합니다.": "The uncompressed Excel file must be 50 MiB or smaller.",
    "외부 참조를 포함한 Excel 파일은 사용할 수 없습니다.": "Excel files with external references are not supported.",
    "이 서버에서는 XLS를 읽을 수 없습니다. XLSX로 변환해주세요.": "This server cannot read XLS files. Convert the file to XLSX.",
    "파일은 빈 행 포함 10,001행, 64열 이내여야 합니다.": "The file must have no more than 10,001 rows, including blanks, and 64 columns.",
    "소속 커뮤니티를 확인해주세요.": "Check your community membership.",
    "업로드한 파일 주소를 확인해주세요.": "Check the uploaded file URL.",
    "업로드한 파일을 찾을 수 없습니다.": "The uploaded file could not be found.",
    "직접 업로드한 파일만 등록할 수 있습니다.": "You can only import files you uploaded yourself.",
    "업로드한 CSV, XLSX 또는 XLS 파일을 선택해주세요.": "Select an uploaded CSV, XLSX or XLS file.",
    "파일은 10 MiB 이하로 업로드해주세요.": "Upload a file of 10 MiB or smaller.",
    "업로드한 파일 경로를 확인해주세요.": "Check the uploaded file path.",
    "업로드한 파일을 읽을 수 없습니다.": "The uploaded file could not be read.",
    "파일 내용을 확인해주세요.": "Check the file contents.",
    "파일을 읽지 못했습니다. 잠시 후 다시 시도해주세요.": "The file could not be read. Try again shortly.",
    "계정 또는 소속 정보가 변경되었습니다. 다시 로그인해주세요.": "Your account or community membership has changed. Sign in again.",
    "전체 등록을 완료하지 못했습니다. 같은 파일로 다시 시도해주세요.": "The import could not be completed. Retry the same file.",
    "실적 파일 처리가 완료되었습니다.": "Research file processing is complete.",
    "8자 이내로 입력해주세요.": "Enter 8 characters or fewer.",
    "32자 이내로 입력해주세요.": "Enter 32 characters or fewer.",
    "64자 이내로 입력해주세요.": "Enter 64 characters or fewer.",
    "128자 이내로 입력해주세요.": "Enter 128 characters or fewer.",
    "16384자 이내로 입력해주세요.": "Enter 16384 characters or fewer.",
    "행 번호": "Row number",
    "열 이름": "Column name",
    "등록 건수": "Imported records",
    "성과 파일 업로드": "Import research records",
    "CSV 양식 다운로드": "Download CSV template",
    "제목은 필수입니다. IF를 비우면 0으로 저장됩니다.": "A title is required. A blank IF is saved as 0.",
    "첫 행의 열 이름을 유지해주세요. Excel은 첫 번째 시트만 등록합니다.": "Keep the column names in the first row. Only the first Excel worksheet is imported.",
    "선택한 파일": "Selected file",
    "파일을 전송하고 있습니다.": "Uploading the file.",
    "성과를 확인하고 등록하고 있습니다.": "Checking and importing research records.",
    "성과 업로드가 완료되었습니다.": "Research import completed.",
    "이미 등록": "Already imported",
    "빈 행 제외": "Blank rows skipped",
    "행별 오류": "Row errors",
    "확인 사항": "Details",
    "오류를 수정한 파일을 다시 선택해주세요.": "Correct the errors and select the updated file.",
    "같은 파일로 다시 시도": "Retry the same file",
    "목록 새로고침": "Refresh list",
    "성과는 저장됐지만 목록을 새로 불러오지 못했습니다.": "The records were saved, but the list could not be refreshed.",
    "파일은 한 번에 하나만 선택해주세요.": "Select one file at a time.",
    "XLSX, CSV, XLS 파일만 업로드할 수 있습니다.": "Only XLSX, CSV and XLS files can be uploaded.",
    "빈 파일은 업로드할 수 없습니다.": "An empty file cannot be uploaded.",
    "파일 크기는 10 MiB 이하여야 합니다.": "The file must be 10 MiB or smaller.",
    "성과 파일을 처리하지 못했습니다.": "The research file could not be processed.",
    "파일 전송에 실패했습니다. 같은 파일로 다시 시도해주세요.": "The file upload failed. Retry the same file.",
    "등록 결과를 확인하지 못했습니다. 같은 파일로 다시 시도해주세요.": "The import result could not be confirmed. Retry the same file.",
    "티켓함": "Ticket mailboxes",
    "보낸 티켓": "Sent tickets",
    "받은 티켓": "Received tickets",
    "전체 티켓 관리": "Manage all tickets",
    "전체 티켓": "All tickets",
    "미완료": "Open",
    "최근 최대 3건": "Up to 3 recent tickets",
    "티켓을 불러오는 중입니다.": "Loading tickets.",
    "티켓을 불러오지 못했습니다.": "Could not load tickets.",
    "티켓 목록을 불러오지 못했습니다.": "Could not load the ticket list.",
    "보낸 티켓이 없습니다.": "No sent tickets.",
    "미완료 티켓이 없습니다.": "No open tickets.",
    "미입력": "Not provided",
    "신원증명자 / 지도교수": "Identity verifier / Academic advisor",
    "PI 성명에 줄바꿈이나 제어 문자를 사용할 수 없습니다.": "PI names cannot contain line breaks or control characters.",
    "PI 성명 (선택)": "PI name (optional)",
    "신원증명자, 지도교수 성함 입력 요망": "Please enter the name of your identity verifier or academic advisor.",
    "PI가 없는 경우 비워두세요.": "Leave this blank if you do not have a PI.",
    "PI 성명은 128자 이내로 입력해주세요.": "Enter a PI name of 128 characters or fewer.",
    "서비스 담당자 변경": "Change service manager",
    "해당 커뮤니티의 사용자를 선택해주세요.": "Select a user from this community.",
    "이름·아이디·이메일 검색": "Search by name, ID or email",
    "서비스 담당자 후보 페이지": "Service manager candidate pages",
    "계정 설정·승인 완료 후 지정 가능": "Available after account setup and approval",
    "지정할 수 없는 계정": "This account cannot be assigned",
    "기존 담당자는 개인연구자로 변경됩니다.": "The previous manager will become an individual researcher.",
    "지정 중...": "Assigning...",
    "선택한 사용자 지정": "Assign selected user",
    "서비스 담당자가 지정되었습니다.": "The service manager has been assigned.",
    "담당자는 변경되었지만 안내 메일을 보내지 못했습니다.": "The manager was changed, but the notification email could not be sent.",
    "처리 결과를 확인하지 못했습니다. 새로 조회 후 다시 시도해주세요.": "Could not confirm the result. Refresh the list and try again.",
    "해당 커뮤니티의 활성 사용자를 선택해주세요.": "Select an active user from this community.",
    "다른 커뮤니티의 담당자 지정 상태를 먼저 확인해주세요.": "Check the manager assignments in other communities first.",
    "기존 시스템 관리자 계정은 자동으로 변경할 수 없습니다.": "The existing system administrator account cannot be changed automatically.",
    "커뮤니티의 _users 기본 그룹을 확인해주세요.": "Check the community’s _users base group.",
    "기존 담당자의 커뮤니티 정보를 먼저 확인해주세요.": "Check the previous manager’s community first.",
    "새로 조회": "Refresh list",
    "시스템 관리자 계정으로 돌아온 뒤 진행해주세요.": "Return to the system administrator account before continuing.",
    "기존 OTP 인증번호": "Existing OTP code",
    "기존 OTP 인증번호 6자리를 입력해주세요.": "Enter the 6-digit code from your existing authenticator.",
    "기존 OTP 사용 여부를 확인하고 있습니다.": "Checking your existing OTP settings.",
    "현재 사용 중인 인증 앱의 6자리 번호를 입력해주세요.": "Enter the 6-digit code from the authenticator you currently use.",
    "기존 OTP 사용 시에만 인증 앱의 6자리 번호를 입력해주세요.": "If you already use OTP, enter the 6-digit code from your authenticator.",
    "새 OTP는 다음 단계에서 등록합니다.": "You will register a new OTP in the next step.",
    "목록을 불러오지 못했습니다. 다시 시도해주세요.": "Could not load the list. Please try again.",
    "처리 결과를 확인하지 못했습니다. 같은 사용자로 다시 시도해주세요.": "The result could not be confirmed. Retry the same user.",
    "기본 그룹에 소속된 활성 사용자인지 확인해주세요.": "Check that the user is active and belongs to the default group.",
    "LDAP에는 반영됐지만 포털 저장을 확인하지 못했습니다. 같은 사용자로 다시 시도해주세요.": "LDAP was updated, but portal storage was not confirmed. Retry the same user.",
    "LDAP 구성원 추가를 완료하지 못했습니다. 같은 사용자로 다시 시도해주세요.": "LDAP membership could not be confirmed. Retry the same user.",
    "추가 중...": "Adding...",
    "선택한 구성원 추가": "Add selected members",
    "추가할 구성원 페이지": "Available users pages",
    "추가할 구성원이 없습니다.": "No users available to add.",
    "추가 완료": "Added",
    "구성원 추가 중": "Adding members",
    "추가할 구성원 검색": "Search users to add",
    "기본 그룹에 소속되어 있고, 이 그룹에는 가입하지 않은 사용자입니다.": "Users in the default group who are not members of this group.",
    "그룹 구성원 추가": "Add group members",
    "인증한 이메일이 계정에 반영됩니다.": "Your verified email will be saved to your account.",
    "변경한 이메일로 인증번호를 다시 받아주세요.": "Request a new verification code for the updated email.",
    "새 창에서 열기": "Open in new window",
    "연구지원 도우미 닫기": "Close research assistant",
    "연구지원 도우미": "Research assistant",
    "새로 사용할 비밀번호를 입력해주세요.": "Enter a new password for your account.",
    "9자 이상 · 영문, 숫자, 특수문자 포함": "At least 9 characters, with letters, numbers and symbols",
    "새 비밀번호를 다시 입력해주세요.": "Enter your new password again.",
    "새 OTP 인증번호": "New OTP code",
    "인증 앱에서 다음 회차의 새 번호를 입력해주세요.": "Wait for the next code in your authenticator app, then enter it.",
    "처음 선택한 비밀번호로 변경을 이어갑니다.": "Continue using the password selected in your first attempt.",
    "설정 중...": "Saving...",
    "설정 다시 시도": "Retry setup",
    "비밀번호 설정": "Set password",
    "OTP 설정 완료": "OTP setup complete",
    "OTP 설정": "OTP setup",
    "로그인에 사용할 OTP를 설정합니다.": "Set up an authenticator for sign-in.",
    "비밀번호와 OTP로 로그인해주세요.": "Sign in with your password and OTP.",
    "OTP 설정 단계": "OTP setup steps",
    "QR 발급": "Create QR",
    "앱 등록": "Add to app",
    "설정 완료": "Complete",
    "OTP 등록 QR 코드": "OTP enrollment QR code",
    "QR 코드를 인증 앱에 등록한 뒤, 앱에 표시되는 6자리 번호를 입력해주세요.": "Add the QR code to your authenticator app, then enter the 6-digit code shown in the app.",
    "QR 코드를 발급한 뒤 인증 앱에 등록해주세요.": "Create a QR code and add it to your authenticator app.",
    "같은 QR 코드로 발급을 이어갑니다.": "Continue setup with the same QR code.",
    "발급 중...": "Creating...",
    "발급 다시 시도": "Retry creation",
    "인증 앱에 표시되는 현재 번호를 입력해주세요.": "Enter the current code from your authenticator app.",
    "인증이 확인되었습니다. 남은 설정을 완료해주세요.": "Code verified. Complete the remaining setup.",
    "확인하고 완료": "Verify and finish",
    "인증 앱 등록과 계정 설정이 완료되었습니다.": "Your authenticator and account setup are complete.",
    "로그인으로 이동": "Go to sign in",
    "다음 회차의 새 OTP 인증번호 6자리를 입력해주세요.": "Enter a fresh 6-digit code from the next OTP interval.",
    "새 OTP 인증번호 6자리를 입력해주세요.": "Enter a fresh 6-digit OTP code.",
    "앱에 표시된 OTP 인증번호 6자리를 입력해주세요.": "Enter the 6-digit code shown in your authenticator app.",
    "비밀번호가 설정되었습니다. 새로운 OTP를 발급해주세요.": "Password saved. Set up your new OTP.",
    "비밀번호가 설정되었습니다. 새 비밀번호와 다음 회차의 OTP로 로그인해주세요.": "Password saved. Sign in with your new password and the next OTP code.",
    "OTP 설정이 완료되었습니다. 비밀번호와 OTP로 다시 로그인해주세요.": "OTP setup complete. Sign in again with your password and OTP.",
    "OTP가 초기화되었습니다. 이메일로 받은 초기 비밀번호로 OTP 없이 로그인한 뒤 새 비밀번호와 OTP를 설정해주세요.": "OTP has been reset. Sign in without OTP using the initial password emailed to you, then set a new password and OTP.",
    "OTP가 초기화되었습니다. 비밀번호로 OTP 없이 로그인한 뒤 새 OTP를 등록해주세요.": "OTP has been reset. Sign in with your password without OTP, then register a new OTP.",
    "인증시간이 만료되었습니다. 인증번호를 재발급해주세요.": "The verification code has expired. Request a new code.",
    "인증번호 재발급": "Resend code",
    "재발급 가능까지": "Resend available in",
    "초기화가 완료되었습니다. 이메일로 발송된 초기 비밀번호로 로그인해주세요.": "Reset complete. Log in with the initial password sent to your email.",
    "OTP가 초기화되었습니다. 비밀번호로 로그인하여 새로운 OTP를 발급해주세요.": "OTP has been reset. Log in with your password to set up a new OTP.",
    "초기화에 실패했습니다.": "Reset failed.",
    "인증메일 발송에 실패했습니다.": "Failed to send the verification email.",
    '이메일 인증 남은 시간': 'Email verification time remaining',
    '남은 시간': 'Time remaining',
    '승인 재시도': 'Retry approval',
    '중단되거나 실패한 가입·그룹 처리를 이어서 진행하시겠습니까?': 'Resume the interrupted or failed account or group request?',
    '계정 생성이 시작된 요청은 거절할 수 없습니다. 승인을 다시 시도해주세요.': 'Account creation has started. Retry approval instead of rejecting the request.',
    'LDAP 계정 생성을 완료하지 못했습니다. 같은 요청을 다시 승인해주세요.': 'Could not finish LDAP account creation. Retry approval for the same request.',
    "설명 저장": "Save description",
    "담당자 변경은 확인 후 즉시 적용됩니다.": "Manager changes take effect immediately after confirmation.",
    "설정 변경은 확인 후 즉시 적용됩니다.": "Setting changes take effect immediately after confirmation.",
    "이 그룹을 조회할 권한이 없습니다.": "You do not have permission to view this group.",
    "그룹을 찾을 수 없습니다.": "Group not found.",
    "연구자 목록을 불러오지 못했습니다.": "Could not load the researchers.",
    "이 커뮤니티를 조회할 권한이 없습니다.": "You do not have permission to view this community.",
    "커뮤니티를 찾을 수 없습니다.": "Community not found.",
    "커뮤니티 정보를 불러오지 못했습니다.": "Could not load the community details.",
    "사용자 정보를 불러오지 못했습니다.": "Could not load your user information.",
    "처리 결과를 확인하지 못했습니다. 신청·승인 내역을 확인한 후 다시 시도해주세요.": "Could not confirm the result. Check Requests and approvals before trying again.",

    "중간 승인 생략 후 승인": "Skip intermediate approvals",
    "그룹 대표(PI) 승인과 남은 중간 승인 단계를 생략하고 최종 승인하여 계정을 생성하시겠습니까?": "Skip PI approval and any remaining intermediate approvals, then give final approval to create the account?",
    "공개": "Visible",
    "숨김": "Hidden",
    "그룹 설정을 확인해주세요.": "Check the group settings.",
    "가입 신청이 마감된 그룹입니다.": "This group is closed to new join requests.",
    "가입 신청 허용 설정을 변경하시겠습니까?": "Change whether this group accepts join requests?",
    "그룹 대표(PI)가 없는 그룹은 추가 가입 목록에 표시되지 않습니다.": "Groups without a PI do not appear in the join list.",
    "숨김 상태에서는 가입 신청을 받지 않습니다.": "Hidden groups do not accept join requests.",
    "신규 가입 신청을 받습니다. 이미 접수된 요청은 계속 처리할 수 있습니다.": "Accept new join requests. Existing requests can still be processed.",
    "다른 연구자의 그룹 목록에 표시합니다. 기존 구성원은 항상 조회할 수 있습니다.": "Show the group to other researchers. Existing members can always view it.",
    "가입 마감": "Closed to new members",
    "가입 신청 허용": "Allow join requests",
    "그룹 공개": "Group visibility",
    "그룹 공개 및 가입 설정": "Group visibility and join settings",
    "생략 승인 재시도": "Retry bypass approval",
    "커뮤니티 대표 승인을 생략하고 연구그룹을 생성하며 신청자를 그룹 대표(PI)로 지정하시겠습니까?": "Skip community representative approval, create the research group, and assign the applicant as its PI?",
    "대표 승인 생략 후 승인": "Skip representative & approve",
    "커뮤니티 대표 승인을 생략하고 최종 승인하여 계정을 생성하시겠습니까?": "Skip community representative approval and give final approval to create the account?",
    "대표 승인 대기": "Awaiting representative approval",
    "대표 승인 완료": "Representative approved",
    "대표 승인 생략": "Representative approval skipped",
    "대표 승인 거절": "Representative rejected",
    "커뮤니티 대표가 없으면 서비스 담당자가 바로 승인합니다.": "The service manager approves directly when no community representative is assigned.",
    "승인 절차는 활성 커뮤니티 대표 지정 여부에 따라 자동으로 적용됩니다.": "The approval process follows the current active community representative assignments.",
    "관리 권한은 커뮤니티 정보에서 담당자로 지정한 후 부여됩니다.": "Management access is granted after assignment in Community information.",
    "계정이 생성되었습니다. 커뮤니티 정보에서 서비스 담당자로 지정해주세요.": "Account created. Assign the service manager in Community information.",
    "지정 시 관리 권한과 승인 업무가 새 담당자에게 이전됩니다.": "Assignment transfers management access and approvals to the new manager.",
    "선택한 계정으로 관리 권한과 승인 업무를 넘기시겠습니까?": "Transfer management access and approvals to this account?",
    "서비스 담당자가 변경되었습니다. 새로 조회 후 다시 지정해주세요.": "The service manager has changed. Refresh before assigning again.",
    "담당자가 변경되었습니다.": "Service manager updated.",
    "가입 가능한 활성 PI를 선택해주세요.": "Select an active PI for this group.",
    "이미 진행 중인 그룹 추가 가입 요청이 있습니다. 신청 내역에서 확인해주세요.": "A request to join this group is already in progress. Check your requests.",
    "같은 그룹의 요청을 처리 중입니다. 신청 내역을 확인해주세요.": "A request for this group is being processed. Check your requests.",
    "설정은 완료되었지만 안내 메일을 보내지 못했습니다. 관리자에게 문의해주세요.": "Setup is complete, but the notification email could not be sent. Please contact an administrator.",
    "다만 일부 안내 메일을 보내지 못했습니다. 관리자에게 문의해주세요.": "Some notification emails could not be sent. Please contact an administrator.",
    "화면을 전환하지 못했습니다. 다시 시도해주세요.": "Could not switch views. Please try again.",
    "처리 확인 필요": "Review processing status",
    "요청을 처리 중입니다. 잠시 후 다시 조회해주세요.": "This request is being processed. Please reload shortly.",
    "요청 상태가 변경되었습니다. 다시 조회해주세요.": "The request status has changed. Please reload.",
    "이미 처리되었거나 승인 단계를 확인할 수 없는 요청입니다.": "This request has already been processed or its approval stage cannot be verified.",
    "LDAP 반영이 시작된 요청입니다. 승인을 다시 시도해주세요.": "LDAP processing has started. Please retry approval.",
    "신청자의 활성 상태와 소속 커뮤니티를 확인해주세요.": "Please check the applicant’s active status and community membership.",
    "처리 결과를 확인하지 못했습니다. 목록을 새로 조회한 후 승인을 다시 시도해주세요.": "Could not confirm the result. Reload the list and retry approval.",
    "LDAP 반영을 완료하지 못했습니다. 승인을 다시 시도해주세요.": "LDAP updates could not be completed. Please retry approval.",
    "요청은 승인되었지만 안내 메일을 보내지 못했습니다.": "The request was approved, but the notification email could not be sent.",
    "요청 처리에 실패했습니다. 목록을 확인한 후 다시 시도해주세요.": "The request failed. Check the list before trying again.",
    "처리 결과를 확인하지 못했습니다. 목록을 확인한 후 다시 시도해주세요.": "Could not confirm the result. Check the list before trying again.",
    "그룹 요청은 연구그룹의 신청·승인 내역에서 처리해주세요.": "Please process group requests in Research Groups → Requests & Approvals.",

    '그룹명 또는 설명 검색': 'Search group name or description',
    '연구그룹 목록을 불러오지 못했습니다.': 'Unable to load research groups.',
    '페이지 탐색': 'Page navigation',

    "역할": "Role",
    "검색": "Search",
    "전체 커뮤니티": "All communities",
    "승인 요청": "Approval requests",
    "콘텐츠": "Content",
    "운영 관리": "Operations",
    "계정·커뮤니티 관리": "Accounts & Communities",
    "서비스 운영": "Service Operations",
    "콘텐츠 관리": "Content Management",
    "전체 사용자": "All users",
    "전체 커뮤니티 운영 현황": "Community operations overview",
    "활성 커뮤니티": "Active communities",
    "회원가입 대기": "Pending signups",
    "커뮤니티 상태": "Community status",
    "정보 관리": "Manage info",
    "가입 절차": "Signup process",
    "미지정": "Not assigned",
    "실제 소속과 대표 지정 정보를 기준으로 표시합니다.": "Roles reflect current memberships and representative assignments.",
    "전체 역할": "All roles",
    "전체 상태": "All statuses",
    "조회 결과": "Results",
    "아이디, 이름, 이메일, 소속기관": "Account, name, email, institution",
    "사용자 목록을 불러오지 못했습니다.": "Could not load users.",
    "조건에 맞는 사용자가 없습니다.": "No users match these filters.",
    "사용자 전환": "Switch user",
    "전환": "Switch",
    "선택한 사용자의 권한으로 접속합니다. 수행한 작업은 실제 반영됩니다.": "You will use this account’s permissions. Actions will affect real data.",
    "상단의 ‘관리자로 돌아가기’로 복귀할 수 있습니다.": "Use “Return to administrator” at the top to switch back.",
    "사용자 계정으로 접속 중": "Using user account",
    "관리자로 돌아가기": "Return to administrator",
    "관리자 복귀에 실패했습니다.": "Could not return to administrator.",
    "사용자 전환에 실패했습니다.": "Could not switch user.",
    "관리자 직접 승인": "Admin approval",
    "관리자 승인 재시도": "Retry admin approval",
    "중간 승인 단계를 생략하고 최종 승인하시겠습니까?": "Skip intermediate approvals and give final approval?",
    "최종 승인": "Approved by",
    "가입 처리 결과를 저장하지 못했습니다. 같은 요청을 다시 승인해주세요.": "Could not save the signup result. Retry approval for this request.",
    "신청자의 상태와 소속 커뮤니티를 확인해주세요.": "Check the applicant's status and community.",
    "가입 요청의 그룹 정보를 확인해주세요.": "Check the group information in the signup request.",
    "가입 요청의 커뮤니티와 그룹 정보가 일치하지 않습니다.": "The signup request's community and group do not match.",
    "승인 요청 목록을 불러오지 못했습니다.": "Could not load approval requests.",
    "요청 처리에 실패했습니다.": "Could not process the request.",
    "가입 진행 중": "Signup in progress",
    "시스템 관리자만 사용할 수 있습니다.": "Only a system administrator can use this feature.",
    "전환할 수 없는 계정입니다.": "This account is not available for switching.",
    "복귀할 관리자 세션이 없습니다.": "No administrator session is available to restore.",
    "관리자 권한을 확인할 수 없습니다. 다시 로그인해주세요.": "Administrator access could not be verified. Please sign in again.",
    "올바른 조회 조건을 선택해주세요.": "Select valid filters.",
    "올바른 페이지를 선택해주세요.": "Select a valid page.",
    "모든 커뮤니티에 동일한 회원가입 절차가 적용됩니다.": "All communities follow the same signup approval process.",
    "가입 완료 후 연구그룹에 가입 신청하면 해당 그룹의 PI가 승인합니다.": "After signup, apply to join a research group. Its PI approves the group membership.",
    "개인연구자 가입 신청": "Individual researcher signup",
    "절차 보기": "View process",
    "현재 승인 단계의 담당자만 처리할 수 있습니다.": "Only the approver for the current stage can process this request.",
    "이미 처리되었거나 처리 중인 요청입니다.": "This request has already been processed or is being processed.",
    "다른 사용자가 요청을 처리했습니다. 다시 조회해주세요.": "Another user processed this request. Please reload.",
    "회원가입 승인 절차는 커뮤니티 대표 → 서비스 담당자로 통일되었습니다.": "Signup now requires approval from the community leader, followed by the service manager.",
    "승인자 확인 필요": "Check approvers",
    "설정을 저장하지 못했습니다.": "Could not save the setting.",
    "설정 처리 결과를 확인하지 못했습니다. 다시 조회해주세요.": "Could not confirm the setting. Please reload.",
    "다른 사용자가 설정을 변경했습니다. 다시 조회해주세요.": "Another user changed this setting. Please reload.",
    "회원가입 승인 절차를 선택해주세요.": "Select a signup approval process.",
    "회원가입 절차를 설정할 권한이 없습니다.": "You do not have permission to configure signup approval.",
    "비활성": "Inactive",
    "활성": "Active",
    "승인자 미지정:": "Approver not assigned:",
    "승인 절차 선택": "Select an approval process",
    "승인 순서": "Approval order",
    "다시 조회": "Reload",
    "커뮤니티 추가": "Add community",
    "커뮤니티 검색": "Search communities",
    "변경한 절차는 새 회원가입 요청부터 적용됩니다.": "Changes apply to new signup requests.",
    "회원가입 승인 절차": "Signup approval process",
    "전체 커뮤니티 관리": "All communities",
    "완료": "Completed",
    "진행 중": "In progress",
    "요청 목록을 불러오지 못했습니다.": "Could not load the requests.",
    "조건에 맞는 처리 이력이 없습니다.": "No matching request history.",
    "진행 중인 요청이 없습니다.": "No requests in progress.",
    "처리 진행 중": "Processing",
    "처리 결과": "Outcome",
    "처리 이력": "History",
    "요청 처리 상태": "Request progress",
    "그룹 목록을 불러오지 못했습니다.": "Could not load the groups.",
    "그룹 대표 관리": "Group leader management",
    "그룹 대표(PI) 해제": "Remove group leader (PI)",
    "그룹 대표(PI)로 지정하시겠습니까?": "Assign this member as a group leader (PI)?",
    "그룹 대표(PI)를 해제하시겠습니까?": "Remove this member as a group leader (PI)?",
    "그룹 대표 변경을 완료하지 못했습니다.": "Could not update the group leader.",
    "그룹 대표 변경 결과를 확인하지 못했습니다. 다시 조회해주세요.": "Could not confirm the group leader change. Please reload.",
    "그룹 대표를 지정할 권한이 없습니다.": "You do not have permission to assign group leaders.",
    "해당 커뮤니티의 그룹 대표를 지정할 권한이 없습니다.": "You do not have permission to assign group leaders in this community.",
    "구성원": "Members",
    "선택한 커뮤니티": "Selected community",
    "그룹 관리": "Group management",
    "그룹 정보": "Group info",
    "그룹 구성원": "Group members",
    "그룹 대표(PI)": "Group leader (PI)",
    "그룹 대표(PI) 지정": "Assign group leader (PI)",
    "제목 검색": "Search titles",
    "제목·태그 검색": "Search title or tags",
    "공지사항 수정": "Edit notice",
    "필터": "Filter",
    "첨부파일 삭제": "Remove attachment",
    "그룹 활성화": "Activate group",
    "문서 편집": "Edit document",
    "경로": "Path",
    "문서 정보": "Document info",
    "편집": "Edit",
    "미리보기": "Preview",
    "연구자 목록 페이지": "Researcher pages",
    "이름·아이디·이메일·소속 검색": "Search name, ID, email or affiliation",
    "현재 담당자": "Current manager",
    "티켓·승인 요청 담당 · 확인 후 바로 적용": "Tickets and approvals · Applied after confirmation",
    "커뮤니티 설명 원문": "Community description source",
    "커뮤니티 설명": "Community description",
    "설명 편집 모드": "Description editor mode",
    "PI는 대표자 변경 후 탈퇴할 수 있습니다. 관리자에게 요청해주세요.": "A PI can leave after a replacement is assigned. Contact an administrator.",
    "그룹 대표자 정보를 확인해야 합니다. 관리자에게 문의해주세요.": "Group representative information needs review. Contact an administrator.",
    "기본 그룹과 관리용 그룹에서는 탈퇴할 수 없습니다.": "You cannot leave base or administrative groups.",
    "그룹 탈퇴": "Leave group",
    "이름·아이디·이메일·소속기관 검색": "Search name, ID, email or institution",
    "그룹 메뉴": "Group actions",
    "연구자 구분": "Researcher type",
    "계정": "Account",
    "요청 처리": "Actions",
    "좌우로 스크롤": "Scroll horizontally",
    "승인 대기": "Awaiting approval",
    "불러오는 중...": "Loading...",
    "요청 내역": "Requests",
    "요청자": "Requester",
    "표시할 요청이 없습니다.": "No requests to display.",
    "요청 목록 페이지": "Request pages",
    "요청 유형": "Request type",
    "소속 / 연구자 구분": "Affiliation / Researcher type",
    "그룹 생성": "Create group",
    "PI를 선택하세요": "Select a PI",
    "PI 선택": "Select PI",
    "표시할 그룹이 없습니다": "No groups to display",
    "소속 그룹": "My groups",
    "제목순": "By title",
    "게시글": "Posts",
    "게시글 내용": "Post content",
    "게시글 수정": "Edit post",
    "게시글 작성": "Write a post",
    "답글 삭제": "Delete reply",
    "댓글 목록": "Comments",
    "댓글 수": "Comment count",
    "게시판 페이지": "Board pages",
    "게시글 정렬": "Sort posts",
    "게시글 제목 검색": "Search post titles",
    "정렬": "Sort",
    "가나다(ABC)순": "Title (A–Z)",
    "출판일순": "Latest publication",
    "업로드순": "Newest upload",
    "페이지당 5개": "5 per page",
    "이동": "Go",
    "다음 페이지": "Next page",
    "이전 페이지": "Previous page",
    "마지막 페이지": "Last page",
    "첫 페이지": "First page",
    "페이지 이동": "Go to page",
    "페이지당 10개": "10 per page",
    "표시 범위": "Showing",
    "성과 목록을 불러오지 못했습니다.": "Could not load research outputs.",
    "성과 목록을 불러오는 중입니다.": "Loading research outputs.",
    "예: 2024, 2024/01 또는 2024/01/01.": "e.g. 2024, 2024/01 or 2024/01/01",
    "예: 1-15, 23-35": "e.g. 1-15, 23-35",
    "예: 1234-5678": "e.g. 1234-5678",
    "성과 목록": "Research outputs",
    "성과 제목 검색": "Search research titles",
    "성과 페이지": "Research output pages",
    "성과 수정": "Edit research output",
    "제목 / 저널": "Title / Journal",
    "출판 정보": "Publication details",
    "증빙 파일": "Supporting files",
    "자주 묻는 질문": "Frequently asked questions",
    "제목 또는 태그로 검색": "Search by title or tag",
    "FAQ 검색": "Search FAQs",
    "전체 질문 보기": "View all questions",
    "전체 질문": "All questions",
    "등록된 질문이 없습니다": "No questions available",
    "다른 검색어로 찾아보세요.": "Try a different search term.",
    "FAQ 페이지": "FAQ pages",
    "FAQ 목록": "All FAQs",
    "이용 방법을 찾고 계신가요?": "Looking for instructions?",
    "매뉴얼 보기": "View manuals",
    "답변": "Answer",
    "첨부 파일 삭제": "Remove attachment",
    "티켓 검색": "Search tickets",
    // Manual reader: translate complete UI labels instead of partial word matches.
    "문서 목록": "Documents",
    "선택한 문서를 찾을 수 없습니다. 문서 목록에서 다시 선택해주세요.": "The selected document could not be found. Please choose another document from the list.",
    "문서 목록 닫기": "Close document list",
    "매뉴얼 문서": "Manual documents",
    "문서명·경로 검색": "Search titles or paths",
    "이 문서의 목차": "On this page",
    "문서가 없습니다": "No documents available",
    "검색 결과가 없습니다": "No search results",
    "문서를 불러오는 중입니다": "Loading document",
    "매뉴얼 목록을 불러올 수 없습니다.": "Could not load the document list.",
    "문서를 불러올 수 없습니다.": "Could not load the document.",
    "섹션이 없습니다": "No sections",
    "LLM 대화창": "AI assistant",
    "LLM 대화창 닫기": "Close AI assistant",
    "다음 댓글": "Next comments",
    "이전 댓글": "Previous comments",
    "댓글 페이지": "Comment page",
    "댓글이 없습니다.": "No comments yet.",
    "파일 열기": "Open file",
    "공지사항 탐색": "Notice navigation",
    "새 공지": "New notice",
    "검색어 지우기": "Clear search",
    "중요": "Important",
    "중요 공지로 상단 고정": "Pin as an important notice",
    "검색 결과": "Search results",
    "공지사항 검색": "Search notices",
    "공지사항 목록": "Notice list",
    "소속 커뮤니티 연도별 연구 성과": "Your community's annual research output",
    "성과 정보를 불러오지 못했습니다.": "Research output could not be loaded.",
    "출판 연도 미확인": "Unknown publication year",
    "출판 연도": "Publication year",
    "기간 외": "Outside this period",
    "소속 커뮤니티 성과": "Your community's research output",
    "소속 커뮤니티 정보가 없습니다.": "No community membership is available.",
    "커뮤니티별 성과": "Research output by community",
    "연구 성과": "Research output",
    "마이페이지 메뉴": "My page navigation",
    "계정 정보를 확인해주세요.": "Please check the account details.",
    "생성 중...": "Creating...",
    "계정 안내는 이메일로 발송됩니다.": "Account details will be sent by email.",
    "선택 사항": "Optional",
    "확인 중...": "Checking...",
    "계정 정보": "Account information",
    "진행 단계": "Progress",
    "본인 확인": "Verify identity",
    "초기화": "Reset",
    "초기 비밀번호를 이메일로 받고 새 비밀번호를 설정합니다.": "Receive an initial password by email, then set a new password.",
    "기존 OTP는 유지됩니다.": "Your existing OTP remains active.",
    "기존 OTP를 초기화한 뒤 새 OTP를 등록합니다.": "Reset your existing OTP, then register a new one.",
    "다시 로그인할 때는 현재 비밀번호만 입력하세요.": "Use only your current password when signing in again.",
    "완료 안내 확인 후 로그아웃됩니다.": "You will be signed out after confirming completion.",
    "본인 확인이 완료되었습니다.": "Identity verified.",
    "초기화가 완료되지 않았습니다. 다시 시도해주세요.": "The reset is incomplete. Please try again.",

    "그룹 처리 결과를 확인하지 못했습니다. 같은 그룹으로 다시 시도해주세요.": "The group operation could not be confirmed. Retry with the same group.",
    "그룹을 관리할 권한이 없습니다.": "You do not have permission to manage groups.",
    "해당 커뮤니티의 그룹을 관리할 권한이 없습니다.": "You do not have permission to manage groups in this community.",
    "그룹을 처리 중입니다. 잠시 후 다시 시도해주세요.": "A group operation is in progress. Please try again shortly.",
    "삭제 중인 그룹입니다. 삭제를 다시 시도해주세요.": "This group is being deleted. Retry the deletion.",
    "그룹 이름과 소속 커뮤니티는 변경할 수 없습니다.": "The group name and community cannot be changed.",
    "그룹 저장을 확인하지 못했습니다. 다시 시도해주세요.": "The group save could not be confirmed. Please try again.",
    "기본 그룹과 관리용 그룹은 삭제할 수 없습니다.": "Base groups and administrative groups cannot be deleted.",
    "그룹 정보가 변경되었습니다. 관리자에게 문의해주세요.": "The group information has changed. Please contact an administrator.",
    "LDAP 그룹 삭제를 완료하지 못했습니다. 다시 시도해주세요.": "Directory group deletion could not be completed. Please try again.",
    "LDAP 삭제는 확인됐지만 포털 정리를 완료하지 못했습니다. 다시 시도해주세요.": "Directory deletion was confirmed, but portal cleanup could not be completed. Please try again.",
    "그룹 정보를 불러오지 못했습니다.": "Could not load the group information.",
    "그룹 저장에 실패했습니다.": "Could not save the group.",
    "그룹 삭제를 완료하지 못했습니다. 다시 시도해주세요.": "Group deletion could not be completed. Please try again.",
    "그룹 공개 설정을 변경하시겠습니까?": "Change the group visibility?",
    "삭제가 진행 중입니다. 삭제 재시도로 완료해주세요.": "Deletion is pending. Select Retry deletion to finish.",
    "삭제 재시도": "Retry deletion",
    "그룹 이름 (변경 불가)": "Group name (read-only)",
    "남아 있는 그룹 정보를 확인해야 합니다. 관리자에게 문의해주세요.": "Remaining group records need review. Please contact an administrator.",
    "다시 적용하기": "Apply again",
    "처리 결과를 확인하지 못했습니다. 다시 시도해주세요.": "The result could not be confirmed. Please try again.",
    "이메일 변경 상태를 확인하지 못했습니다.": "The email change status could not be checked.",
    "로그인이 만료되었습니다. 다시 로그인해주세요.": "Your session has expired. Please sign in again.",
    "이메일 변경 권한을 확인하지 못했습니다. 다시 로그인해주세요.": "Your permission to change email could not be confirmed. Please sign in again.",
    "이메일 변경 기능에 연결하지 못했습니다. 관리자에게 문의해주세요.": "The email change service could not be reached. Please contact an administrator.",
    "이메일 변경 요청에 실패했습니다. 잠시 후 다시 시도해주세요.": "The email change request failed. Please try again shortly.",
    "인증이 완료되었습니다. 다시 적용하기를 눌러 변경을 완료해주세요.": "Verification is complete. Select Apply again to finish changing your email.",
    "본인 확인 시간이 만료되었습니다. 다시 인증해주세요.": "Your identity verification has expired. Please verify again.",
    "새 이메일과 현재 비밀번호 및 OTP를 입력해주세요.": "Enter your new email, current password and OTP.",
    "이메일 변경을 처리 중입니다. 잠시 후 다시 확인해주세요.": "An email change is in progress. Please check again shortly.",
    "계정 상태가 변경되었습니다. 다시 로그인해주세요.": "Your account status has changed. Please sign in again.",
    "이메일 정보가 변경되었습니다. 관리자에게 문의해주세요.": "The email information has changed. Please contact an administrator.",
    "본인 확인 후 이메일 변경을 다시 시작해주세요.": "Verify your identity to restart the email change.",
    "진행 중인 이메일 변경을 먼저 완료해주세요.": "Complete the pending email change first.",
    "이미 인증한 이메일의 변경을 완료해주세요.": "Complete the change to the email you have already verified.",
    "본인 확인 시간이 만료되었습니다. 같은 이메일로 다시 인증해주세요.": "Your identity verification has expired. Verify again with the same email.",
    "LDAP 이메일 반영을 확인하지 못했습니다. 다시 적용해주세요.": "The directory email update could not be confirmed. Please apply again.",
    "LDAP 반영은 완료됐지만 포털 저장을 확인하지 못했습니다. 다시 적용해주세요.": "The directory was updated, but the portal save could not be confirmed. Please apply again.",
    "이메일 변경 상태를 확인하지 못했습니다. 잠시 후 다시 시도해주세요.": "The email change status could not be confirmed. Please try again shortly.",
    "아이디는 영문 소문자 또는 밑줄로 시작하는 1~64자의 소문자·숫자·밑줄·점·하이픈이어야 합니다.": "Use 1–64 lowercase letters, numbers, underscores, dots or hyphens, starting with a letter or underscore.",
    "아이디 중복 여부를 확인하지 못했습니다. 잠시 후 다시 확인해주세요.": "ID availability could not be checked. Please try again shortly.",
    "이미 제출된 가입 요청입니다. 가입 상태를 확인해주세요.": "This signup request has already been submitted. Please check its status.",
    "가입 요청을 저장하지 못했습니다. 잠시 후 다시 시도해주세요.": "Your signup request could not be saved. Please try again shortly.",
    "같은 아이디의 계정이 등록되었습니다. 계정 정보를 확인 후 다시 시도해주세요.": "An account with this ID has been registered. Check its details before retrying.",
    "포털 계정 저장을 완료하지 못했습니다. 같은 정보로 다시 시도해주세요.": "The portal account could not be saved. Please retry with the same details.",
    "기본 정보는 각 항목 64자 이내의 텍스트로 입력해주세요.": "Enter text of up to 64 characters in each profile field.",
    "전체 이름은 공백을 포함해 64자 이내로 입력해주세요.": "Your full name must be 64 characters or fewer, including the space.",
    "소속 커뮤니티 정보를 확인할 수 없습니다. 관리자에게 문의해주세요.": "Your community could not be confirmed. Please contact an administrator.",
    "LDAP 기본 정보 반영을 완료하지 못했습니다. 같은 내용으로 다시 저장해주세요.": "The directory update could not be completed. Save the same details again.",
    "LDAP 기본 정보 반영 결과를 확인하지 못했습니다. 다시 저장해주세요.": "The directory update could not be confirmed. Please save again.",
    "LDAP 정보는 반영되었지만 포털 저장을 확인하지 못했습니다. 같은 내용으로 다시 저장해주세요.": "The directory was updated, but the portal save could not be confirmed. Save the same details again.",
    "저장 결과를 확인하지 못했습니다. 같은 내용으로 다시 저장해주세요.": "The save result could not be confirmed. Save the same details again.",
    "OTP 등록": "OTP setup",
    "계정 설정 진행 단계": "Account setup steps",
    "계정 설정 완료": "Account setup complete",
    "인증 앱에서 QR 코드를 스캔해주세요.": "Scan the QR code in your authenticator app.",
    "OTP 사용자는 새 인증번호를 입력해주세요.": "If you use OTP, enter a fresh code.",
    "가입 완료": "Complete registration",
    "처리 중": "Processing",
    "수집 항목 및 이용 목적": "Information collected and purpose",
    "보유 및 이용 기간": "Retention and use period",
    "6자리 인증번호": "6-digit code",
    "유효시간 5분": "Valid for 5 minutes",
    "유효시간 60분": "Valid for 60 minutes",
    "인증번호 6자리를 입력해주세요.": "Enter the 6-digit verification code.",
    "이전": "Back",
    "커뮤니티를 불러오는 중입니다.": "Loading communities.",
    "커뮤니티 목록을 불러오지 못했습니다.": "Could not load communities.",
    "다시 불러오기": "Reload",
    "커뮤니티의 기본 그룹이 설정되지 않았습니다. 관리자에게 문의해주세요.": "The community base group is not configured. Please contact an administrator.",
    "다음": "Next",
    // Registration privacy screen
    "회원가입 진행 단계": "Registration steps",
    "개인정보 동의": "Privacy consent",
    "이메일 인증": "Email verification",
    "계정 정보 입력": "Account details",
    "이름 및 연락처 데이터": "Name and contact data",
    "사용자의 성과 이름, 메일 주소 및 기타 유사한 연락처 데이터.": "User's first and last name, email address, and similar contact data.",
    "자격 증명": "Credentials",
    "비밀번호, 인증과 계정 액세스에 사용되는 유사한 보안 정보.": "Passwords and similar security information used for authentication and account access.",
    "로그인으로 돌아가기": "Back to login",
    "동의하고 계속하기": "Agree and continue",

    // =========================================================================
    // 메뉴 / 네비게이션
    // =========================================================================
    '대시보드': 'Dashboard',
    '공지사항 관리': 'Notice Management',
    '공지사항': 'Notices',
    '기술지원': 'Technical Support',
    '매뉴얼 이미지 관리': 'Manual Image Management',
    '매뉴얼 관리': 'Manual Management',
    '매뉴얼': 'Manual',
    '티켓팅 관리': 'Ticketing Management',
    '티켓팅': 'Ticketing',
    '성과 관리': 'Research Management',
    '성과': 'Research Output',
    '게시판 관리': 'Board Management',
    '게시판': 'Board',
    '스토리지 관리': 'Storage Management',
    '스토리지 모니터링': 'Storage Monitoring',
    '전체 스토리지 모니터링': 'Full Storage Monitoring',
    '스토리지': 'Storage',
    '연구커뮤니티 연구자': 'Community Researchers',
    '연구그룹 연구자': 'Group Researchers',
    '연구그룹 수': 'Number of Research Groups',
    '연구그룹이 없습니다.': 'No research groups found.',
    '연구그룹': 'Research Group',
    '연구 커뮤니티명': 'Research Community Name',
    '연구 커뮤니티 정보': 'Research Community Info',
    '연구 커뮤니티': 'Research Community',
    '연구 그룹 정보': 'Research Group Info',
    '연구 그룹 목록': 'Research Group List',
    '연구 그룹 명': 'Research Group Name',
    '연구 그룹 추가': 'Add Research Group',
    '연구 그룹이 추가되었습니다.': 'Research group has been added.',
    '연구 그룹': 'Research Group',
    '그룹 목록': 'Group List',
    '요청 목록': 'Request List',
    '신청·승인 내역': 'Requests & Approvals',
    '연구성과': 'Research Output',
    '문의하기': 'Contact Support',
    '마이페이지': 'My Page',
    '커뮤니티 관리': 'Community Management',
    '승인 요청 관리': 'Approval Request Management',
    '사용자 관리': 'User Management',
    'FAQ 관리': 'FAQ Management',
    '비밀번호 변경': 'Change Password',
    '사용자': 'User',
    '관리': 'Management',
    '정보': 'Info',
    '연구자 목록': 'Researcher List',
    '연구자가 없습니다.': 'No researchers found.',
    '연구자': 'Researchers',
    '커뮤니티 대표': 'Community Leader',
    '커뮤니티': 'Community',
    '홈': 'Home',
    '상세보기': 'Detail View',
    '상세 정보': 'Detail Info',
    '상세 내용': 'Detail Content',
    '신규 생성': 'New',
    '작성': 'Write',
    '목록으로': 'Back to List',
    '목록': 'List',
    '그룹 대표': 'Group Leader (PI)',
    '서비스 담당자가 없습니다.': 'No service managers found.',
    '계정 유형': 'Account Type',
    '계정 유형을 확인해주세요.': 'Check the account type.',
    '이미 다른 서비스 담당자가 연결된 커뮤니티입니다. 커뮤니티 정보에서 담당자 설정을 확인해주세요.': 'This community already has a service manager. Check the manager assignment in Community Information.',
    '담당 커뮤니티 연결을 완료하지 못했습니다. 같은 정보로 다시 시도해주세요.': 'Could not complete the community assignment. Retry with the same details.',
    '담당 커뮤니티가 다른 계정에 배정되었습니다. 커뮤니티 정보에서 담당자 설정을 확인해주세요.': 'This community was assigned to another account. Check the manager assignment in Community Information.',
    '포털 계정 활성화를 완료하지 못했습니다. 같은 정보로 다시 시도해주세요.': 'Could not activate the portal account. Retry with the same details.',
    '서비스 담당자': 'Service Manager',
    '개인 연구자': 'Individual Researcher',
    '관리자': 'Admin',
    '폴더 구조': 'Folder Structure',
    '댓글': 'Comments',
    '티켓 처리': 'Ticket Processing',
    '및': 'and',

    // =========================================================================
    // 버튼 / 액션
    // =========================================================================
    '관리자용 로그인': 'Admin Login',
    '로그인에 실패했습니다.': 'Login failed.',
    '로그인 하러가기': 'Go to Login',
    '로그인': 'Log In',
    '올바르지 않은 계정 이름입니다.': 'Invalid account name.',
    '가입되지 않은 계정입니다.': 'This account is not registered.',
    '가입되지 않은 계정입니다. 계정을 만드시겠습니까?': 'This account is not registered. Would you like to create one?',
    '관리자의 승인을 기다리고 있습니다': 'Waiting for administrator approval.',
    '계정 이름 또는 비밀번호를 확인해주세요': 'Please check your account name or password.',
    '아이디와 비밀번호를 확인해주세요.': 'Please check your ID and password.',
    '사용자 정보를 찾을 수 없습니다.': 'User information could not be found.',
    '회원가입 승인 요청 중입니다.': 'Sign-up approval is pending.',
    '회원가입 요청에 실패했습니다.': 'Sign-up request failed.',
    '회원가입 처리 중 오류가 발생했습니다.': 'An error occurred during sign-up.',
    '회원가입 요청': 'Sign-up Request',
    '회원가입 + 신규 그룹 생성 요청': 'Sign-up + New Group Request',
    '회원가입 완료': 'Sign-up Completed',
    '회원가입 거절': 'Sign-up Rejected',
    '회원가입': 'Sign Up',
    '인증메일 다시 보내기': 'Resend Verification Email',
    '인증메일 보내기': 'Send Verification Email',
    '인증하기': 'Verify',
    '동의하기': 'Agree',
    '중복확인': 'Check Duplicate',
    '저장되었습니다.': 'Saved successfully.',
    '저장되었습니다': 'Saved successfully.',
    '저장하기': 'Save',
    '저장': 'Save',
    '삭제되었습니다.': 'Deleted successfully.',
    '삭제하기': 'Delete',
    '삭제에 실패했습니다.': 'Deletion failed.',
    '삭제': 'Delete',
    '수정하기': 'Edit',
    '수정': 'Edit',
    '취소': 'Cancel',
    '닫기': 'Close',
    '확인': 'Confirm',
    '승인하시겠습니까?': 'Approve this request?',
    '승인 중 오류가 발생했습니다.': 'Error during approval.',
    '승인 완료': 'Approved',
    '승인': 'Approve',
    '거절하시겠습니까?': 'Reject this request?',
    '거절 중 오류가 발생했습니다.': 'Error during rejection.',
    '거절': 'Reject',
    '추가': 'Add',
    '생성하기': 'Create',
    '변경되었습니다. 다시 로그인해주세요.': 'Changed. Please log in again.',
    '변경되었습니다.': 'Changed successfully.',
    '변경하기': 'Change',
    '변경에 실패했습니다.': 'Change failed.',
    'PI 지정/해제에 실패했습니다. 다시 시도해주세요.': 'Failed to update the PI assignment. Please try again.',
    '처리하기': 'Process',
    '처리 내용': 'Process Content',
    '요청 제출': 'Submit Request',
    '요청이 승인되었습니다.': 'Request approved.',
    '요청이 거절되었습니다.': 'Request rejected.',
    '선택완료': 'Selection Complete',
    '작성하기': 'Write',
    '다운로드': 'Download',
    '업로드 진행 중': 'Upload in progress',
    '업로드에 실패했습니다.': 'Upload failed.',
    '업로드 중 오류가 발생했습니다.': 'Error during upload.',
    '업로드': 'Upload',
    '파일 업로드': 'Upload File',
    '파일 선택': 'Select File',
    '파일 첨부': 'Attach File',
    '파일을 여기에 드롭하세요': 'Drop files here',
    '파일이 없습니다': 'No files',
    '폴더 업로드에 실패했습니다.': 'Folder upload failed.',
    '폴더 업로드 중 오류가 발생했습니다.': 'Error during folder upload.',
    '폴더 업로드': 'Upload Folder',
    '폴더 생성에 실패했습니다.': 'Failed to create folder.',
    '폴더 생성': 'Create Folder',
    '폴더 이름을 입력하세요.': 'Please enter a folder name.',
    '이름 변경에 실패했습니다.': 'Rename failed.',
    '이름 변경': 'Rename',
    '사본 만들기': 'Make a Copy',
    '사본 생성에 실패했습니다.': 'Failed to create copy.',
    '댓글 작성': 'Post Comment',
    '답글 작성': 'Post Reply',
    '답글': 'Reply',
    '엑셀 업로드에 실패하였습니다.': 'Excel upload failed.',
    '엑셀 업로드': 'Upload Excel',
    '더보기': 'View More',
    '이전글': 'Previous Post',
    '다음글': 'Next Post',
    '계정 만들기': 'Create Account',
    '사용자 추가': 'Add User',
    '연구커뮤니티 추가': 'Add Research Community',
    '성과 추가': 'Add Research Output',
    '티켓 추가': 'Add Ticket',
    '신규 그룹 생성을 요청하시겠습니까?': 'Submit a new group creation request?',
    '신규 그룹 생성': 'Create New Group',
    '그룹 추가 가입 요청에 실패했습니다.': 'Group join request failed.',
    '그룹 추가 가입 요청이 성공적으로 제출되었습니다.': 'Group join request submitted.',
    '그룹 추가 가입': 'Join Additional Group',
    '그룹 추가 완료': 'Group Join Completed',
    '그룹 추가 거절': 'Group Join Rejected',
    '상위 폴더로 이동': 'Go to parent folder',
    '그룹 가입 요청':   'Request to Join Group',

    // =========================================================================
    // 비밀번호 / OTP / 인증
    // =========================================================================
    '비밀번호 및 OTP 초기화 이메일 인증': 'Password & OTP Reset Email Verification',
    '비밀번호 및 OTP 초기화': 'Reset Password & OTP',
    '비밀번호와 OTP가 초기화되었습니다. 초기 비밀번호로 로그인 후 OTP를 새로 발급받으세요.': 'Password and OTP have been reset. Log in with the initial password and reissue your OTP.',
    '비밀번호 초기화 이메일 인증': 'Password Reset Email Verification',
    '비밀번호 초기화가 완료되었습니다.\n초기 비밀번호는 이메일로 발송되었습니다.\n메일을 확인하여 비밀번호 재설정을 진행해주세요.': 'Password has been reset.\nThe initial password was sent to your email.\nPlease check your email to set a new password.',
    '비밀번호 초기화 실패': 'Password reset failed.',
    '비밀번호 초기화': 'Reset Password',
    '비밀번호 재설정': 'Reset Password',
    '비밀번호를 초기화하시겠습니까?': 'Reset your password?',
    '비밀번호 인증 성공': 'Password verified successfully.',
    '비밀번호 인증 실패': 'Password verification failed.',
    '비밀번호 인증': 'Verify Password',
    '비밀번호가 성공적으로 재설정되었습니다. OTP 발급 페이지로 이동합니다.': 'Password reset successfully. Redirecting to OTP issuance page.',
    '비밀번호가 성공적으로 재설정되었습니다. 로그인 페이지로 이동합니다.': 'Password reset successfully. Redirecting to login page.',
    '비밀번호가 일치하지 않습니다.': 'Passwords do not match.',
    '비밀번호는 9자리 이상, 숫자, 문자, 특수문자를 포함해야 합니다.': 'Password must be at least 9 characters with numbers, letters, and special characters.',
    '비밀번호 확인을 입력해주세요.': 'Please confirm your password.',
    '비밀번호 확인': 'Confirm Password',
    '비밀번호 + OTP': 'Password + OTP',
    '비밀번호를 입력해주세요.': 'Please enter your password.',
    'OTP 인증번호': 'OTP code',
    '초기 비밀번호로 로그인하는 경우 비워두세요.': 'Leave blank when signing in with an initial password.',
    'OTP 인증번호는 숫자 6자리로 입력해주세요.': 'Enter a 6-digit OTP code.',
    '새 비밀번호를 입력해주세요.': 'Please enter a new password.',
    '새 비밀번호': 'New Password',
    '현재 비밀번호 입력': 'Enter Current Password',
    '현재 비밀번호를 입력해주세요.': 'Please enter your current password.',
    '변경 비밀번호를 다시 확인해주세요': 'Please re-confirm the new password.',
    '변경 비밀번호': 'New Password',
    '비밀번호': 'Password',
    'OTP 초기화 이메일 인증': 'OTP Reset Email Verification',
    'OTP를 초기화하시겠습니까?': 'Reset your OTP?',
    'OTP 초기화가 완료되었습니다.\n재접속하여 OTP 재발급을 진행해주세요': 'OTP has been reset.\nPlease reconnect to issue a new OTP.',
    'OTP 재발급 실패': 'OTP reissue failed.',
    'OTP가 성공적으로 발급되었습니다.': 'OTP issued successfully.',
    'OTP가 초기화되었습니다. 이제 비밀번호로 로그인하여 새로운 OTP를 발급해 주세요.': 'OTP has been reset. Please log in with your password to issue a new OTP.',
    'OTP 초기화': 'OTP Reset',
    'OTP 발급을 위해 아래 단계를 따르세요.': 'Follow the steps below to issue an OTP.',
    'OTP 발급': 'OTP Issuance',
    '이메일 인증 코드가 발송되었습니다.': 'Verification code has been sent.',
    '이메일이 확인되었습니다. 인증 코드를 발송합니다.': 'Email verified. Sending verification code.',
    '이메일이 확인되었습니다. 회원가입을 진행하세요.': 'Email verified. Please continue with sign-up.',
    '이메일 인증 코드 발송에 실패했습니다.': 'Failed to send verification code.',
    '이메일 인증 코드 발송 중 오류가 발생했습니다': 'Error sending verification code.',
    '잘못된 이메일 형식입니다': 'Invalid email format.',
    '가입되지 않은 회원입니다.': 'This member is not registered.',
    '이미 사용중인 이메일 입니다': 'This email is already in use.',
    '인증 성공': 'Verification successful.',
    '잘못된 인증번호 입니다': 'Invalid verification code.',
    '잘못된 인증번호 입니다.': 'Invalid verification code.',
    '인증 시간이 만료되었습니다.': 'Verification time has expired.',
    '이메일 인증을 다시 진행해주세요.': 'Please verify your email again.',
    '해당 이메일로 가입된 회원이 없습니다.': 'No member is registered with this email.',
    '등록되지 않은 이메일 또는 계정 이름입니다.': 'The email or account name is not registered.',
    '회원가입 승인 대기 중입니다. 승인 완료 후 이용해주세요.': 'Your sign-up is pending approval. Please use the service after approval is complete.',
    '회원가입이 거절된 계정입니다. 사용하실 수 없습니다.': 'This sign-up request was rejected. This account cannot be used.',
    '계정 설정이 완료되지 않았습니다. 계정 설정 완료 후 사용해주세요.': 'Account setup is not complete. Please use the service after finishing setup.',
    '잘못된 이메일, 계정 이름 또는 인증번호입니다.': 'The email, account name, or verification code is invalid.',
    '인증 코드가 유효하지 않거나 초기화에 실패했습니다.': 'Invalid verification code or reset failed.',
    '인증 코드가 유효하지 않거나 전송에 실패했습니다.': 'Invalid verification code or sending failed.',
    '인증 코드가 유효하지 않거나 재설정에 실패했습니다.': 'Invalid verification code or reset failed.',
    '초기 비밀번호가 이메일로 전송되었습니다.': 'Initial password has been sent to your email.',
    '회원가입 요청이 성공적으로 접수되었습니다.': 'Your sign-up request has been successfully received.',
    '플레이북 실행에 실패했습니다:': 'Playbook execution failed:',
    '비밀번호 초기화에 실패했습니다:': 'Password reset failed:',
    'OTP 초기화에 실패했습니다:': 'OTP reset failed:',
    'OTP 발급에 실패했습니다:': 'OTP issuance failed:',
    'LDAP 비밀번호 재설정에 실패했습니다:': 'Failed to reset LDAP password:',
    '로그인이 필요합니다.': 'Login is required.',
    '존재하지 않는 사용자명입니다.': 'This username does not exist.',
    'ID와 Password는 필수 입력 값입니다.': 'ID and password are required.',

    // =========================================================================
    // 폼 라벨 / Placeholder
    // =========================================================================
    // Community login page
    '연구 커뮤니티와 함께 시작하세요.': 'Your research community starts here.',
    '커뮤니티를 선택하세요': 'Select your community',
    'OTP 사용자는 비밀번호 뒤에 인증번호 6자리를 입력하세요.': 'Using OTP? Append the 6-digit code to your password.',
    '비밀번호 숨기기': 'Hide password',
    '비밀번호 보기': 'Show password',
    '계정 복구': 'Account recovery',
    '아직 계정이 없으신가요?': 'New to GSDC?',
    '연구를 연결하고,': 'Connecting research.',
    '가능성을 넓히다.': 'Expanding possibilities.',
    '데이터와 컴퓨팅으로 이어지는 연구의 시작.': 'Where research meets data and computing.',
    'GSDC가 함께합니다.': 'Discover more with GSDC.',
    '아이디와 비밀번호를 입력하고 로그인하세요.': 'Enter your ID and password to log in.',
    '아이디는 소문자와 숫자, 언더바만 가능합니다.': 'ID can only contain lowercase letters, numbers, and underscores.',
    '아이디는 소문자, 숫자, 언더바만 가능합니다.': 'ID can only contain lowercase letters, numbers, and underscores.',
    '사용 가능한 아이디입니다.': 'This ID is available.',
    '이미 사용 중인 아이디입니다.': 'This ID is already in use.',
    '아이디를 입력해주세요.': 'Please enter an ID.',
    '아이디 중복 확인을 해주세요.': 'Please check ID availability.',
    '아이디, 이름, 이메일, 소속기관으로 검색...': 'Search by ID, name, email, institution...',
    '아이디': 'ID',
    '이메일을 입력해주세요.': 'Please enter your email.',
    '올바른 이메일 형식이 아닙니다.': 'Invalid email format.',
    '사용할 수 없는 이메일입니다.': 'This email cannot be used.',
    '유효한 이메일을 입력해주세요.': 'Please enter a valid email.',
    '이메일 입력': 'Enter email',
    '이메일': 'Email',
    '인증번호 입력': 'Enter verification code',
    '인증번호': 'Verification Code',
    '계정 이름 입력': 'Enter account name',
    '계정 이름 (ID)': 'Account Name (ID)',
    '이름을 입력해주세요.': 'Please enter your name.',
    '성을 입력해주세요.': 'Please enter your last name.',
    '성': 'Last Name',
    '이름': 'Name',
    '성 (First Name)': 'First Name',
    '성 (Last Name)': 'Last Name',
    '소속기관': 'Institution',
    '부서/학과': 'Department',
    '연구자구분': 'Researcher Type',
    '커뮤니티 선택에 실패하였습니다.': 'Failed to select community.',
    '커뮤니티 정보를 불러올 수 없습니다.': 'Cannot load community information.',
    '커뮤니티를 선택해주세요.': 'Please select a community.',
    '커뮤니티 선택': 'Select Community',
    '그룹을 선택해주세요.': 'Please select a group.',
    '그룹을 선택하세요': 'Select a group',
    '그룹 선택': 'Select Group',
    '그룹 대표 선택': 'Select Group Leader',
    '대표자를 선택하세요': 'Select a representative',
    '대표자 선택': 'Select Representative',
    '신규 그룹명을 입력하세요': 'Enter new group name',
    '신규 그룹 설명': 'New Group Description',
    '신규 그룹명': 'New Group Name',
    '신규 그룹 이름': 'New Group Name',
    '승인요청 그룹 대표 지정': 'Designate Approval Request Group Leader',
    '연구커뮤니티 명을 입력해주세요.': 'Please enter the community name.',
    '연구커뮤니티 명': 'Research Community Name',
    '연구 그룹 명을 입력해주세요.': 'Please enter the group name.',
    '그룹명을 입력해주세요.': 'Please enter the group name.',
    '그룹 설명을 입력해주세요.': 'Please enter the group description.',
    '그룹 이름과 설명을 입력해 주세요.': 'Please enter group name and description.',
    '그룹 이름': 'Group Name',
    '제목을 입력해주세요': 'Enter title',
    '제목을 입력해주세요.': 'Please enter the title.',
    '제목을 입력하세요': 'Enter title',
    '제목 및 내용 검색': 'Search by title and content',
    '제목, 내용으로 검색...': 'Search by title, content...',
    '제목, 태그으로 검색...': 'Search by title, tag...',
    '제목': 'Title',
    '저자를 입력해주세요': 'Enter author',
    '저자': 'Author',
    '게시 날짜': 'Publication Date',
    '저널명을 입력해주세요': 'Enter journal name',
    '저널': 'Journal',
    '컨퍼런스를 입력해주세요': 'Enter conference',
    '컨퍼런스': 'Conference',
    '권': 'Volume',
    '호': 'Issue',
    '페이지': 'Pages',
    '태그를 선택해주세요.': 'Please select a tag.',
    '태그 선택': 'Select Tag',
    '태그': 'Tags',
    '선택': 'Select',
    '내용을 입력해주세요.': 'Please enter the content.',
    '내용': 'Content',
    '설명': 'Description',
    '공개': 'Visibility',
    '상태가 변경되었습니다.': 'Status has been changed.',
    '상태 변경 실패': 'Status change failed.',
    '상태를 변경하시겠습니까?': 'Change the status?',
    '상태': 'Status',
    '작성자': 'Author',
    '작업자': 'Assignee',
    '생성일': 'Created Date',
    '최종 업데이트': 'Last Updated',
    '논문 첫페이지': 'Paper First Page',
    '논문 사사페이지': 'Paper Acknowledgment Page',
    '기본 정보가 성공적으로 업데이트되었습니다.': 'Basic info updated successfully.',
    '기본 정보 업데이트에 실패했습니다.': 'Failed to update basic info.',
    '기본 정보': 'Basic Info',
    '숫자로 입력해주세요': 'Enter a number',
    '숫자만 입력해주세요(소숫점 가능)': 'Enter numbers only (decimals allowed)',
    '파일 및 폴더 검색': 'Search files and folders',
    '폴더 이름 입력': 'Enter folder name',
    '댓글을 입력하세요...': 'Enter a comment...',
    '댓글을 작성해주세요.': 'Please enter a comment.',
    '댓글을 삭제하시겠습니까?': 'Are you sure you want to delete this comment?',
    '답글을 입력하세요...': 'Enter a reply...',
    '답글을 작성해주세요.': 'Please enter a reply.',
    '문제 상황을 자세히 설명해주세요...': 'Please describe the issue in detail...',
    '티켓 제목을 입력하세요': 'Enter ticket title',
    '그룹에 대한 간략한 설명을 입력하세요.': 'Enter a brief description of the group.',
    '서비스 담당자로 설정할 연구커뮤니티를 선택하세요.': 'Select the community to assign as service manager.',
    '기존 연구 그룹에 추가로 가입하기 위한 그룹을 선택하세요.': 'Select a group to join additionally.',

    // =========================================================================
    // 메시지 (Alert / Confirm / Error)
    // =========================================================================
    '오류가 발생했습니다.': 'An error occurred.',
    '정말로 삭제하시겠습니까?': 'Are you sure you want to delete?',
    '정말 변경하시겠습니까?': 'Are you sure you want to change?',
    '권한을 선택해주세요.': 'Please select a role.',
    '다시 시도': 'Retry',
    '사용자 정보를 불러오는 데 실패했습니다.': 'Failed to load user information.',
    '사용자가 성공적으로 생성되었습니다.': 'User created successfully.',
    '사용자 생성에 실패했습니다.': 'Failed to create user.',
    '사용자가 없습니다.': 'No users found.',
    '표시할 사용자가 없습니다.': 'No users to display.',
    '표시할 커뮤니티가 없습니다.': 'No communities to display.',
    '현재 승인 대기 중인 요청이 없습니다.': 'No pending approval requests.',
    'PI 승인 절차를 선택해주세요.': 'Please select the PI approval process.',
    '개인 연구자 승인 절차를 선택해주세요.': 'Please select the researcher approval process.',
    'PI 지정/해제 완료했습니다.': 'PI designation/release completed.',
    '해당 사용자를 PI로 지정하시겠습니까?': 'Designate this user as PI?',
    '해당 사용자를 PI에서 해제하시겠습니까?': 'Remove PI designation from this user?',
    '연구커뮤니티 대표 지정/해제 완료했습니다.': 'Community leader designation/release completed.',
    '해당 사용자를 연구커뮤니티 대표로 지정하시겠습니까?': 'Designate this user as community leader?',
    '해당 사용자를 연구커뮤니티 대표 해제하시겠습니까?': 'Remove community leader designation?',
    '해당 연구그룹을 삭제하시겠습니까?': 'Delete this research group?',
    '그룹 생성 요청이 성공적으로 제출되었습니다.': 'Group creation request submitted.',
    '그룹 생성 요청에 실패했습니다.': 'Group creation request failed.',
    '그룹 생성 완료': 'Group Created',
    '그룹 생성 거절': 'Group Creation Rejected',
    '그룹 목록을 불러오는 중 오류가 발생했습니다.': 'Error loading group list.',
    '대표자 목록을 불러오는 중 오류가 발생했습니다.': 'Error loading representative list.',
    '그룹과 대표자를 선택해 주세요.': 'Please select a group and representative.',
    '선택한 그룹에 추가 가입 요청을 하시겠습니까?': 'Submit a request to join the selected group?',
    '성과 업로드 완료되었습니다.': 'Research output uploaded.',
    '같은 이름의 폴더가 이미 존재합니다.': 'A folder with this name already exists.',
    '이미 현재 위치에 같은 이름의 파일이 있습니다': 'A file with the same name already exists here.',
    '이미 현재 위치에 같은 이름의 폴더가 있습니다': 'A folder with the same name already exists here.',
    '이미 존재하는 이름의 파일이 있습니다.': 'A file with this name already exists.',
    '이미 존재하는 이름의 파일/폴더가 있습니다.': 'A file/folder with this name already exists.',
    '이름을 비울 수 없습니다.': 'Name cannot be empty.',
    '같은 이름의 항목이 이미 존재합니다.': 'An item with this name already exists.',
    '폴더를 자기 자신이나 하위 폴더로 이동할 수 없습니다.': 'Cannot move a folder into itself or its subfolder.',
    '이동에 실패했습니다.': 'Move failed.',
    '이미지 파일만 업로드할 수 있습니다.': 'Only image files can be uploaded.',
    '저장공간이 부족합니다.': 'Insufficient storage space.',
    '저장공간이 부족하여 업로드할 수 없습니다.': 'Cannot upload due to insufficient storage.',
    '검색 모드에서는 파일 업로드를 할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.': 'Cannot upload files in search mode.\nClear the search and try again.',
    '검색 모드에서는 폴더 업로드를 할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.': 'Cannot upload folders in search mode.\nClear the search and try again.',
    '검색 모드에서는 드래그 앤 드롭 업로드를 할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.': 'Cannot drag-and-drop upload in search mode.\nClear the search and try again.',
    '검색 모드에서는 폴더를 생성할 수 없습니다.\n검색을 해제한 후 다시 시도해 주세요.': 'Cannot create folders in search mode.\nClear the search and try again.',
    'GSDC 계정 생성을 위한 요청이 완료되었습니다.': 'Your GSDC account creation request has been submitted.',

    // =========================================================================
    // 역할 / 상태 라벨
    // =========================================================================
    '시스템관리자': 'System Admin',
    '시스템 관리자': 'System Admin',
    '계정 역할': 'Account roles',
    '서비스담당자': 'Service Manager',
    '커뮤니티대표': 'Community Leader',
    '그룹대표': 'Group Leader',
    '개인연구자': 'Individual Researcher',
    '전체 공개': 'Public',
    '커뮤니티 공개': 'Community Only',
    '전체': 'All',
    '모두': 'All',
    '접수대기': 'Pending',
    '접수완료': 'Received',
    '처리중': 'Processing',
    '처리완료': 'Completed',
    '초안': 'Draft',
    '게시': 'Published',
    '활성화': 'Active',
    '비활성화': 'Inactive',
    '그룹 대표 승인 대기': 'Awaiting Group Leader Approval',
    'PI 승인 대기': 'Awaiting PI Approval',
    'PI 승인 완료': 'PI Approval Completed',
    '커뮤니티 대표 승인 대기': 'Awaiting Community Leader Approval',
    '서비스 담당자 승인 대기': 'Awaiting Service Manager Approval',
    'LDAP에 적용 중': 'Applying to LDAP',
    '최신순': 'Most Recent',
    '가나다순': 'Alphabetical',
    '조회순': 'Most Viewed',
    '평문': 'Plain Text',

    // =========================================================================
    // 테이블 헤더
    // =========================================================================
    '접수일': 'Received Date',
    '처리일': 'Processed Date',
    '출판일': 'Publication Date',
    '작성일': 'Created Date',
    '수정일': 'Modified Date',
    'PI 지정': 'PI Designation',
    '연구커뮤니티 대표 지정': 'Community Leader Designation',
    '서비스 담당자 지정': 'Service Manager Designation',
    '승인 단계': 'Approval Stage',
    '크기': 'Size',
    '작업': 'Actions',

    // =========================================================================
    // 기타 UI
    // =========================================================================
    '앱스토어나 구글스토어에서 "Google Authenticator" 앱을 다운로드하세요.': 'Download "Google Authenticator" from the App Store or Google Play.',
    '앱을 열고, "+" 버튼을 클릭한 후 "QR 코드 스캔"을 선택하세요.': 'Open the app, tap "+", then select "Scan QR Code".',
    '아래 "OTP 발급" 버튼을 클릭하여 QR 코드를 생성하세요.': 'Click the "Issue OTP" button below to generate a QR code.',
    'QR 코드로 설정을 완료하셨나요?': 'Have you completed setup with the QR code?',
    '1. 앱 다운로드': '1. Download the App',
    '2. 앱 설정': '2. Set Up the App',
    '3. OTP 발급': '3. Issue OTP',
    '개인정보의 수집 및 이용': 'Collection and Use of Personal Information',
    '수집하는 개인정보 항목 및 이용 목적:': 'Personal information items collected and purpose:',
    '개인정보의 보유 및 이용 기간': 'Retention and Use Period of Personal Information',
    'PI 승인 절차': 'PI Approval Process',
    '개인 연구자 승인 절차': 'Individual Researcher Approval Process',
    '신규 그룹 생성 요청': 'New Group Creation Request',
    '그룹 추가 가입 요청': 'Group Join Request',
    '새로운 연구 커뮤니티 정보 작성': 'Create New Research Community',
    '성과 상세 정보': 'Research Output Detail',
    'FAQ 상세 정보': 'FAQ Detail',
    'FAQ 작성': 'Create FAQ',
    '게시물 작성': 'Create Post',
    '게시물': 'Post',
    '첨부파일이 없습니다.': 'No attachments.',
    '첨부된 파일': 'Attached Files',
    '첨부 파일': 'Attachments',
    '첨부파일': 'Attachments',
    '게시글이 없습니다': 'No posts found.',
    '공지사항이 없습니다': 'No notices found.',
    '성과가 없습니다': 'No research outputs found.',
    '티켓이 없습니다.': 'No tickets found.',
    '티켓이 없습니다': 'No tickets found.',
    '필요 용량': 'Required space',
    '남은 용량': 'Remaining space',
    '총 용량': 'Total space',
    '사용량': 'Usage',
    '제한 없음': 'Unlimited',
    '루트': 'Root',
    '개 항목': ' items',
    '개 선택됨': ' selected',
    '날짜': 'Date',
    '개인정보': 'Personal Information',
    '라이트 모드': 'Light Mode',
    '다크 모드': 'Dark Mode',
    '테마 전환': 'Toggle Theme',

    // =========================================================================
    // 차트 / 그래프
    // =========================================================================
    '성과 그래프': 'Research Output Graph',
    '건수': 'Count',
    '연구커뮤니티 대표 해제': 'Remove Community Leader',
    '연구커뮤니티 대표 ->': 'Community Leader →',
    '연구커뮤니티 대표': 'Community Leader',
    '연구커뮤니티': 'Research Community',

    // =========================================================================
    // 추가 누락 — 상태/역할 라벨
    // =========================================================================
    'PI 해제': 'Remove PI',
    '그룹 (Groups)': 'Group (Groups)',
    '그룹 설명': 'Group Description',
    '그룹': 'Group',
    '또는': 'or',
    '서비스 담당자용 연구커뮤니티 선택': 'Select Community for Service Manager',
    '시스템': 'System',
    '일반': 'General',
    '지정': 'Designate',
    '해제': 'Remove',
    '행동': 'Action',
    'FAQ 추가': 'Add FAQ',

    // =========================================================================
    // 추가 누락 — Alert / Confirm
    // =========================================================================
    '게시물이 없습니다': 'No posts found.',
    '매뉴얼이 없습니다': 'No manuals found.',
    '승인 요청 목록이 없습니다': 'No approval requests found.',
    '을(를) 삭제하시겠습니까?': 'Do you want to delete?',
    '회원가입 중 오류 발생:': 'Sign-up error:',

    // =========================================================================
    // 추가 누락 — 폼 라벨 / UI
    // =========================================================================
    '관리자용 로그인 비밀번호 변경': 'Admin Login Password Change',
    '관리자 로그인 비밀번호 변경': 'Change Admin Login Password',
    '아이디 (Account Name)': 'ID (Account Name)',
    '이름 (First Name)': 'Name (First Name)',
    '이름 (Full Name)': 'Name (Full Name)',
    '이름 (Last Name)': 'Name (Last Name)',
    '이메일 (Email)': 'Email',
    '이메일 인증 코드가 발송되었습니다': 'Verification code has been sent.',
    '현재 비밀번호': 'Current Password',
    '부서/학과 (Department)': 'Department',
    '소속기관 (Institute)': 'Institution',
    '소속기관 (Institution)': 'Institution',
    '연구자구분 (Role)': 'Researcher Type (Role)',
    '커뮤니티 (Community)': 'Community',
    '연구 커뮤니티 명': 'Research Community Name',

    // =========================================================================
    // 추가 누락 — 페이지 고유 / 카테고리
    // =========================================================================
    'SW 패키지 설치': 'SW Package Installation',
    '귀하가 계정을 생성할 때 GSDC가 수집하는 정보:': 'Information GSDC collects when you create an account:',
    // =========================================================================
    // 누락 항목 추가 — 댓글/티켓/커뮤니케이션
    // =========================================================================
    '커뮤니케이션': 'Communication',
    '티켓 작성': 'Create Ticket',
    '티켓 정보': 'Ticket Info',
    '티켓': 'Ticket',
    '공지사항 작성': 'Create Notice',

    '기타 장애': 'Other Issues',
    '댓글 삭제': 'Delete Comment',
    '데이터셋': 'Dataset',
    '마지막 업데이트:': 'Last updated:',
    '사용자 계정': 'User Account',
    '상태:': 'Status:',
    '서버 퍼포먼스': 'Server Performance',
    '업로드 중...': 'Uploading...',
    '이름 및 연락처 데이터: 사용자의 성과 이름, 메일 주소 및 기타 유사한 연락처 데이터.': 'Name and contact data: user\'s first and last name, email address, and similar contact data.',
    '자격 증명: 비밀번호, 인증과 계정 액세스에 사용되는 유사한 보안 정보.': 'Credentials: passwords and similar security info used for authentication and account access.',
    '첨부된 파일 ()': 'Attached Files ()',
    '최대 10MB, PDF, DOC, XLS, PPT, TXT, 이미지 파일 지원': 'Max 10MB. Supported: PDF, DOC, XLS, PPT, TXT, images',
    '파일': 'File',
    '패스워드': 'Password',
    '폴더/파일명': 'Folder/File Name',
    '폴더명': 'Folder Name',
    '폴더': 'Folder',
    '프로그램 실행': 'Run Program',
    '환경설정': 'Settings',
    // Authentication screens: complete sentences for English translation.
    "로그인 서버 연결이 끊어졌습니다. 잠시 후 다시 시도해주세요.": "The connection to the login server was lost. Please try again shortly.",
    "로그인 서버 응답을 받지 못했습니다. 잠시 후 다시 시도해주세요.": "No response was received from the login server. Please try again shortly.",
    "계정 설정이 완료되지 않았습니다.": "Account setup is not complete.",
    "GSDC는 계정의 생성 및 관리, 서비스의 제공 및 개선, 고객의 계정 또는 서비스 관련 의사소통 및 고객요청 대응을 위해 다음과 같은 데이터를 수집합니다.": "GSDC collects the following data to create and manage accounts, provide and improve services, communicate with customers about their accounts or services, and respond to customer requests.",
    "GSDC는 서비스 제공을 위해서, 또는 법적 의무 준수, 분쟁 해결, 계약 이행과 같은 다른 중요한 목적을 위해 필요한 기간 동안 데이터를 유지합니다.": "GSDC retains data for as long as necessary to provide services or for other important purposes, such as complying with legal obligations, resolving disputes, and fulfilling contracts.",
    "그룹명을 입력하세요": "Enter a group name",
    " 님 GSDC 계정 생성을 위한 요청이 완료되었습니다.": ", your GSDC account creation request has been submitted.",
    "OTP 설정이 완료되지 않았습니다. 비밀번호 및 OTP 초기화를 이용해주세요.": "OTP setup is not complete. Please use Reset Password & OTP.",
    "초기 비밀번호가 이메일로 발송되었습니다.": "The initial password has been sent to your email.",
    "OTP가 초기화되었습니다.": "OTP has been reset.",
    "비밀번호와 OTP가 초기화되었습니다.": "Your password and OTP have been reset.",
    "로그인 서비스에 연결하지 못했습니다. 잠시 후 다시 시도해주세요.": "Unable to reach the login service. Please try again shortly.",
    "로그인 결과를 확인하지 못했습니다. 다시 시도해주세요.": "Unable to confirm the login result. Please try again.",
    "포털 계정 정보를 확인하지 못했습니다. 잠시 후 다시 시도해주세요.": "Unable to check your portal account. Please try again shortly.",
    "초기화 작업이 시작되어 가입 인증이 변경되었습니다. 초기화를 완료한 뒤 다시 로그인해주세요.": "A reset has invalidated this setup session. Finish the reset and sign in again.",
    "진행 중인 설정에는 처음 선택한 새 비밀번호를 사용해주세요.": "Use the new password you originally selected for this setup.",
    "포털 저장을 확인하지 못했습니다. 같은 화면에서 다시 시도해주세요.": "Unable to confirm the portal save. Please retry on this page.",
    "포털 계정 정보를 저장하지 못했습니다. 같은 화면에서 다시 시도해주세요.": "Unable to save the account details. Please retry on this page.",
    "포털 가입 저장을 확인하지 못했습니다. 같은 화면에서 다시 시도해주세요.": "Unable to confirm registration. Please retry on this page.",
    "계정 설정 결과를 확인하지 못했습니다. 같은 화면에서 다시 시도해주세요.": "Unable to confirm account setup. Please retry on this page.",
    "인증 요청을 확인하지 못했습니다. 잠시 후 다시 시도해주세요.": "Unable to process verification. Please try again shortly.",
    "30초 후 인증메일을 다시 요청해주세요.": "Please wait 30 seconds before requesting another verification email.",
    "인증 상태를 확인하지 못했습니다. 잠시 후 다시 시도해주세요.": "Unable to check verification status. Please try again shortly.",
    "인증 시도 횟수를 초과했습니다. 새 인증번호를 발급해주세요.": "Too many verification attempts. Please request a new code.",
    "이름과 소속기관을 확인해주세요. 각 항목은 64자 이내로 입력해주세요.": "Enter your name and institution. Each field must be 64 characters or fewer.",
};
